import {
  Avatar,
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Fragment, useEffect, useState, useTransition } from "react";
import { useNavigate } from "react-router-dom";
import { RouteUrls } from "../../../Constants/RouteUrls";
import { FormDataType } from "DataTypes/Form";
import { commonFormSwitch, ControlledBoxSizeSwitch } from "Utils/SwitchCases";
import { HandleFormChange } from "Utils/Common";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ControlledForm from "Components/ControlledForm";
import authApi from "Service/Auth.api";
import ImgPath from "Constants/Imgs";
import { registrationFormData, skillDataFormArr } from "./Data";
import { SkillArr } from "Constants/Arrays";
import { HandleChangeProps } from "DataTypes/Common";
import { CloseOutlined } from "@mui/icons-material";
import ColorData from "Components/CstmTheme/ColorData";

export interface skillFormArrType {
  id: number;
  skillFormArr: FormDataType[];
}
const ProfessionalRegister = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<FormDataType[]>(
    JSON.parse(JSON.stringify(registrationFormData()))
  );
  const [selectedDocuments, setSelectedDocuments] = useState<File[]>([]);
  const [documentsUploaded, setDocumentsUploaded] = useState<boolean>(false);
  // Add these simple regex checks at the top of your component or file
const validateEmail = (email: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
const validatePhone = (phone: string): boolean => /^\d{10}$/.test(phone);

// Inside your component, add loading states
const [emailLoading, setEmailLoading] = useState(false);
const [contactLoading, setContactLoading] = useState(false);
  const [formData1, setFormData1] = useState<
    | {
        id: number;
        skillFormArr: FormDataType[];
      }[]
    | []
  >([
    {
      id: 1,
      skillFormArr: skillDataFormArr,
    },
  ]);
  const [emailData, setEmailData] = useState<{
    fieldVal: string;
    otpSend: boolean;
    otpVal: string;
    otpVerified: boolean;
  }>({
    fieldVal: "",
    otpSend: false,
    otpVal: "",
    otpVerified: false,
  });
  const [contactData, setContactData] = useState<{
    fieldVal: string;
    otpSend: boolean;
    otpVal: string;
    otpVerified: boolean;
  }>({
    fieldVal: "",
    otpSend: false,
    otpVal: "",
    otpVerified: false,
  });
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  // const handleSendOtp: (otpType: "email" | "contact") => void = async (
  //   otpType
  // ) => {
  //   if (otpType == "email") {
  //     const res = await authApi.emailSendOtp({
  //       email: emailData.fieldVal,
  //       requestType: "register",
  //     });
  //     if (res?.success) {
  //       setEmailData({
  //         fieldVal: emailData.fieldVal,
  //         otpSend: true,
  //         otpVal: "",
  //         otpVerified: false,
  //       });
  //     }
  //   } else {
  //     const res = await authApi.mobileSendOtp({
  //       mobileNumber: contactData.fieldVal,
  //       requestType: "register",
  //     });
  //     if (res?.success) {
  //       setContactData({
  //         fieldVal: contactData.fieldVal,
  //         otpSend: true,
  //         otpVal: "",
  //         otpVerified: false,
  //       });
  //     }
  //   }
  // };
  // const handleVerifyOtp: (otpType: "email" | "contact") => void = async (
  //   otpType
  // ) => {
  //   if (otpType == "email") {
  //     const res = await authApi.verifyOtp({
  //       mobileNumber: null,
  //       email: emailData.fieldVal,
  //       otp: emailData.otpVal,
  //     });
  //     if (res?.success) {
  //       setEmailData({
  //         fieldVal: emailData.fieldVal,
  //         otpSend: true,
  //         otpVal: emailData.otpVal,
  //         otpVerified: true,
  //       });
  //     }
  //   } else {
  //     const res = await authApi.verifyOtp({
  //       mobileNumber: contactData.fieldVal,
  //       email: null,
  //       otp: contactData.otpVal,
  //     });
  //     if (res?.success) {
  //       setContactData({
  //         fieldVal: contactData.fieldVal,
  //         otpSend: true,
  //         otpVal: contactData.otpVal,
  //         otpVerified: true,
  //       });
  //     }
  //   }
  // };


  const handleSendOtp = async (otpType: "email" | "contact") => {
  if (otpType === "email") {
    if (!validateEmail(emailData.fieldVal)) return; // Extra safety
    setEmailLoading(true);
    try {
      const res = await authApi.emailSendOtp({ email: emailData.fieldVal, requestType: "register" });
      if (res?.success) {
        setEmailData({ ...emailData, otpSend: true, otpVal: "", otpVerified: false });
      }
    } finally {
      setEmailLoading(false);
    }
  } else {
    if (!validatePhone(contactData.fieldVal)) return; // Extra safety
    setContactLoading(true);
    try {
      const res = await authApi.mobileSendOtp({ mobileNumber: contactData.fieldVal, requestType: "register" });
      if (res?.success) {
        setContactData({ ...contactData, otpSend: true, otpVal: "", otpVerified: false });
      }
    } finally {
      setContactLoading(false);
    }
  }
};

const handleVerifyOtp = async (otpType: "email" | "contact") => {
  if (otpType === "email") {
    setEmailLoading(true);
    try {
      const res = await authApi.verifyOtp({ mobileNumber: null, email: emailData.fieldVal, otp: emailData.otpVal });
      if (res?.success) {
        setEmailData({ ...emailData, otpVerified: true });
      }
    } finally {
      setEmailLoading(false);
    }
  } else {
    setContactLoading(true);
    try {
      const res = await authApi.verifyOtp({ mobileNumber: contactData.fieldVal, email: null, otp: contactData.otpVal });
      if (res?.success) {
        setContactData({ ...contactData, otpVerified: true });
      }
    } finally {
      setContactLoading(false);
    }
  }
};
  const handleRegister = async () => {
    const selectedRoles = formData[9]?.dropValue;
    const selectedSkills = formData1.map((el) => {
      console.log(el,'el');
      return {
        skillId: el.skillFormArr[0].dropValue,
        // rating: el.skillFormArr[1].value,
        numberOfExperienceYears: el.skillFormArr[1].value,
        description: el.skillFormArr[2].value,
        servesPanIndia: el.skillFormArr[3].dropValue === "yes" ? true : false,
        servesStates: el.skillFormArr[4].dropValue,
      };
    });
    const payload = {
      firstName: formData[0].value,
      lastName: formData[1].value,
      address: formData[2].value,
      city: formData[3].value,
      state: formData[4].dropValue,
      postalCode: formData[5].value,
      dateOfBirth: formData[6].value,
      description: "test",
      password: formData[7].value,
      highestQualification: formData[8].value,
      profilePicturePath: "",
      email: emailData.fieldVal,
      contactNumber: contactData.fieldVal,
      // userType: "Professional",
      roles: selectedRoles,
      skills: selectedSkills || [],
    };

    const res = await authApi.registerProfessional(payload);
    if (res?.success) {
      navigate(`/home.html`);
    }
  };

  const handleAddMore: () => void = () => {
    setFormData1((prev) => [
      ...prev,
      {
        id: prev.length > 0 ? prev[prev.length - 1].id + 1 : 1,
        skillFormArr: JSON.parse(JSON.stringify(skillDataFormArr)),
      },
    ]);
  };
  const removeLocationArr: (id: number) => void = (id) => {
    const newArr = formData1.filter((el) => el.id !== id);
    setFormData1(newArr);
  };

  const handleLocationChange: (
    props: HandleChangeProps,
    orderId: number
  ) => void = (props, orderId) => {
    const { value, id } = props;
    const newFormArr: skillFormArrType[] = JSON.parse(
      JSON.stringify(formData1)
    );

    const formArrIndex = newFormArr.findIndex((el) => el.id === orderId);
    if (formArrIndex !== -1) {
      if (id === "servesPan" && value === "yes") {
        newFormArr[formArrIndex].skillFormArr[4].required = false;
        newFormArr[formArrIndex].skillFormArr[4].readOnly = true;
        newFormArr[formArrIndex].skillFormArr[4].dropValue = [];
        newFormArr[formArrIndex].skillFormArr[4].error = false;
        newFormArr[formArrIndex].skillFormArr[4].errorText = "";
      } else {
        newFormArr[formArrIndex].skillFormArr[4].required = true;
        newFormArr[formArrIndex].skillFormArr[4].readOnly = false;
      }
    }
    const newFormObjArr = HandleFormChange(
      props,
      newFormArr[formArrIndex].skillFormArr
    );
    newFormArr[formArrIndex].skillFormArr = newFormObjArr;
    setFormData1([...newFormArr]);
  };

  const handleDocumentSubmission: () => void = async () => {
    // Call Document Submission API here
    if (!emailData.fieldVal || !contactData.fieldVal) {
      alert(
        "Please fill in Email and Contact Number before uploading documents."
      );
      return;
    }

    const formData = new FormData();
    formData.append("emailId", emailData.fieldVal);
    formData.append("mobileNumber", contactData.fieldVal);

    selectedDocuments.forEach((file, index) => {
      formData.append(`files`, file);
    });

    try {
      const response = await authApi.uploadProfessionalDocuments(formData);

      if (response?.success) {
        setSelectedDocuments([]);
        setDocumentsUploaded(true);
      } else {
        console.log("Failed to upload documents.");
      }
    } catch (error) {
      console.error("Error uploading documents:", error);
    }
  };

  const handlePasswordToggle = (fieldId: string) => {
    setFormData((prev) =>
      prev.map((field) =>
        field.id === fieldId
          ? { ...field, showPassword: !field.showPassword }
          : field
      )
    );
  };

  // return (
  //   <Box sx={{ height: "100vh", overflow: "auto" }}>
  //     <Box
  //       sx={{
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: "space-between",
  //         px: 3,
  //         py: 1,
  //         borderBottom: "1px solid #e0e0e0",
  //       }}
  //     >
  //       <Box
  //         component="img"
  //         src={"https://nolegalpaisa.com/assets/images/nlp_logo.png"}
  //         alt="Logo"
  //         sx={{
  //           width: { xs: "150px", sm: "200px", md: "230px" },
  //           height: { xs: "60px", sm: "80px", md: "83px" },
  //           objectFit: "contain",
  //           cursor: "pointer",
  //           filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.3))",
  //           transition: "transform 0.2s ease-in-out",
  //           "&:hover": {
  //             transform: "scale(1.05)",
  //           },
  //         }}
  //         onClick={() => (window.location.href = "/home.html")}
  //       />
  //       <Typography
  //         component="h1"
  //         variant="h4"
  //         sx={{
  //           flex: 1,
  //           textAlign: "center",
  //           color: "primary.main",
  //           fontWeight: 600,
  //           display: "flex",
  //           alignItems: "center",
  //           justifyContent: "center",
  //           gap: 1,
  //         }}
  //       >
  //         <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
  //           <LockOutlinedIcon />
  //         </Avatar>
  //         Sign Up as Professional
  //       </Typography>
  //       <Box sx={{ width: "180px" }} /> {/* Spacer to balance the layout */}
  //     </Box>
  //     <Grid
  //       container
  //       component="main"
  //       sx={{ flex: 1 }}
  //       alignItems="center"
  //       justifyContent="center"
  //     >
  //       {!isSmallScreen && (
  //         <Grid
  //           sx={{
  //             backgroundRepeat: "no-repeat",
  //             backgroundSize: "cover",
  //             backgroundPosition: "center",
  //             height: "100%",
  //           }}
  //         />
  //       )}
  //       <Grid
  //         sx={{
  //           display: "flex",
  //           alignItems: "center",
  //           justifyContent: "center",
  //           py: 4,
  //         }}
  //       >
  //         <Box
  //           sx={{
  //             mx: 4,
  //             width: "100%",
  //             display: "flex",
  //             flexDirection: "column",
  //             alignItems: "center",
  //           }}
  //         >
  //           <Box component="form" noValidate sx={{ mt: 1, width: "100%" }}>
  //             <Grid mb={2} container columnSpacing={2} rowSpacing={2}>
  //               {formData.map((el: FormDataType) => (
  //                 <Grid
  //                   key={el.id}
  //                   size={{ ...ControlledBoxSizeSwitch(el.boxSize) }}
  //                 >
  //                   {commonFormSwitch({
  //                     //   formObj: el,
  //                     //   onChange: (data) =>
  //                     //     setFormData(HandleFormChange(data, formData)),
  //                     // })}
  //                     formObj: {
  //                       ...el,
  //                       onPasswordToggle: el.hasPasswordToggle
  //                         ? () => handlePasswordToggle(el.id)
  //                         : undefined,
  //                     },
  //                     onChange: (data) =>
  //                       setFormData(HandleFormChange(data, formData)),
  //                   })}
  //                 </Grid>
  //               ))}
  //             </Grid>

  //             <Grid mb={2} container columnSpacing={2} rowSpacing={2}>
  //               <Grid key={"email"} size={{ ...ControlledBoxSizeSwitch(3) }}>
  //                 <ControlledForm.Input
  //                   id="email"
  //                   value={emailData.fieldVal}
  //                   {...(emailData.otpVerified && {
  //                     focused: true,
  //                     borderColor: "success",
  //                     readOnly: true,
  //                   })}
  //                   label="Email"
  //                   onChange={(value) =>
  //                     setEmailData({ ...emailData, fieldVal: value as string })
  //                   }
  //                 />
  //               </Grid>
  //               <Grid
  //                 key={"emailOtp"}
  //                 sx={{
  //                   display: emailData.otpSend === true ? "block" : "none",
  //                 }}
  //                 size={{ ...ControlledBoxSizeSwitch(3) }}
  //               >
  //                 <ControlledForm.Input
  //                   id="emailOtp"
  //                   label="Email OTP"
  //                   {...(emailData.otpVerified === true && {
  //                     iconId: "check-icon",
  //                     infoText: "Email Verified",
  //                     readOnly: true,
  //                   })}
  //                   value={emailData.otpVal}
  //                   onChange={(value) =>
  //                     setEmailData({ ...emailData, otpVal: value as string })
  //                   }
  //                 />
  //               </Grid>
  //               <Grid key={"email"} size={{ ...ControlledBoxSizeSwitch(3) }}>
  //                 <Button
  //                   // fullWidth
  //                   variant="contained"
  //                   sx={{ mt: 3 }}
  //                   onClick={() =>
  //                     emailData.otpSend
  //                       ? handleVerifyOtp("email")
  //                       : handleSendOtp("email")
  //                   }
  //                 >
  //                   {emailData.otpSend === true ? "Verify" : "Send OTP"}
  //                 </Button>
  //                 <IconButton
  //                   sx={{ mt: 3 }}
  //                   title="Reset"
  //                   onClick={() =>
  //                     setEmailData(
  //                       JSON.parse(
  //                         JSON.stringify({
  //                           fieldVal: "",
  //                           otpSend: false,
  //                           otpVal: "",
  //                           otpVerified: false,
  //                         })
  //                       )
  //                     )
  //                   }
  //                 >
  //                   <ImgPath.RestoreIcon />
  //                 </IconButton>
  //               </Grid>
  //             </Grid>

  //             <Grid mb={2} container columnSpacing={2} rowSpacing={2}>
  //               <Grid key={"contact"} size={{ ...ControlledBoxSizeSwitch(3) }}>
  //                 <ControlledForm.Input
  //                   id="contact"
  //                   value={contactData.fieldVal}
  //                   {...(contactData.otpVerified && {
  //                     focused: true,
  //                     borderColor: "success",
  //                     readOnly: true,
  //                   })}
  //                   label="Contact"
  //                   onChange={(value) =>
  //                     setContactData({
  //                       ...contactData,
  //                       fieldVal: value as string,
  //                     })
  //                   }
  //                 />
  //               </Grid>
  //               <Grid
  //                 key={"contactOtp"}
  //                 sx={{
  //                   display: contactData.otpSend === true ? "block" : "none",
  //                 }}
  //                 size={{ ...ControlledBoxSizeSwitch(3) }}
  //               >
  //                 <ControlledForm.Input
  //                   id="contactOtp"
  //                   value={contactData.otpVal}
  //                   {...(contactData.otpVerified && {
  //                     iconId: "check-icon",
  //                     infoText: "Contact Number Verified",
  //                     readOnly: true,
  //                   })}
  //                   label="Contact OTP"
  //                   onChange={(value) =>
  //                     setContactData({
  //                       ...contactData,
  //                       otpVal: value as string,
  //                     })
  //                   }
  //                 />
  //               </Grid>
  //               <Grid key={"contact"} size={{ ...ControlledBoxSizeSwitch(3) }}>
  //                 <Button
  //                   // fullWidth
  //                   variant="contained"
  //                   sx={{ mt: 3 }}
  //                   onClick={() =>
  //                     contactData.otpSend
  //                       ? handleVerifyOtp("contact")
  //                       : handleSendOtp("contact")
  //                   }
  //                 >
  //                   {contactData.otpSend === true ? "Verify" : "Send OTP"}
  //                 </Button>
  //                 <IconButton
  //                   sx={{ mt: 3 }}
  //                   title="Reset"
  //                   onClick={() =>
  //                     setContactData(
  //                       JSON.parse(
  //                         JSON.stringify({
  //                           fieldVal: "",
  //                           otpSend: false,
  //                           otpVal: "",
  //                           otpVerified: false,
  //                         })
  //                       )
  //                     )
  //                   }
  //                 >
  //                   <ImgPath.RestoreIcon />
  //                 </IconButton>
  //               </Grid>
  //             </Grid>

  //             {formData1.map((el, index) => {
  //               return (
  //                 <Fragment>
  //                   <Box>
  //                     <Grid
  //                       container
  //                       sx={{
  //                         display: "flex",
  //                         flexDirection: "row",
  //                         alignItems: "center",
  //                       }}
  //                       mt={2}
  //                       columnSpacing={1}
  //                       rowSpacing={2}
  //                     >
  //                       {el?.skillFormArr?.map((el1) => {
  //                         return (
  //                           <Grid
  //                             key={el.id}
  //                             size={{ ...ControlledBoxSizeSwitch(el1.boxSize) }}
  //                             mt={2}
  //                           >
  //                             {commonFormSwitch({
  //                               formObj: el1,
  //                               onChange: (props) =>
  //                                 handleLocationChange(props, el.id),
  //                             })}
  //                           </Grid>
  //                         );
  //                       })}
  //                       {index !== 0 && (
  //                         <Box
  //                           sx={{
  //                             display: "flex",
  //                             flexDirection: "row",
  //                             justifyContent: "center",
  //                           }}
  //                         >
  //                           {
  //                             <IconButton
  //                               title="Delete"
  //                               onClick={() => removeLocationArr(el.id)}
  //                             >
  //                               <CloseOutlined />
  //                             </IconButton>
  //                           }
  //                         </Box>
  //                       )}
  //                     </Grid>
  //                   </Box>
  //                 </Fragment>
  //               );
  //             })}

  //             <Grid sx={{ mt: 2, mb: 2 }}>
  //               <Button variant="contained" onClick={handleAddMore}>
  //                 Add More
  //               </Button>
  //             </Grid>

  //             <Box
  //               sx={{
  //                 display: "flex",
  //                 flexDirection: "row",
  //                 alignItems: "center",

  //                 width: "30%",
  //               }}
  //             >
  //               <ControlledForm.Input
  //                 id="fileSelection"
  //                 type="file"
  //                 onChange={(value) =>
  //                   setSelectedDocuments(typeof value == "object" ? value : [])
  //                 }
  //                 label="Upload Professional Qualification Documents"
  //                 focused={true}
  //                 readOnly={documentsUploaded}
  //                 {...(documentsUploaded && {
  //                   borderColor: "success",
  //                   infoText: "Documents Uploaded Successfully",
  //                   iconId: "check-icon",
  //                 })}
  //               />

  //               <Button
  //                 variant="contained"
  //                 sx={{
  //                   ml: 3,
  //                   backgroundColor: documentsUploaded ? "#4CAF50" : undefined,
  //                   "&:hover": {
  //                     backgroundColor: documentsUploaded
  //                       ? "#43A047"
  //                       : undefined,
  //                   },
  //                 }}
  //                 onClick={handleDocumentSubmission}
  //                 disabled={documentsUploaded}
  //               >
  //                 {documentsUploaded ? "Upload Documents" : "Upload Documents"}
  //               </Button>
  //             </Box>

  //             <Button
  //               variant="contained"
  //               sx={{ mt: 3 }}
  //               onClick={handleRegister}
  //               disabled={!emailData.otpVerified && !contactData.otpVerified}
  //             >
  //               Sign Up
  //             </Button>

  //             <Typography
  //               sx={{
  //                 textAlign: "center",
  //                 textDecoration: "underline",
  //                 cursor: "pointer",
  //                 mt: 2,
  //               }}
  //               variant="body2"
  //               onClick={() => navigate(`/${RouteUrls.login}`)}
  //             >
  //               Already have an account? Login
  //             </Typography>
  //           </Box>
  //         </Box>
  //       </Grid>
  //     </Grid>
  //   </Box>
  // );


return (
  <Box sx={{ backgroundColor: "#f4f7f9", minHeight: "100vh", pb: 5 }}>
    {/* Header / Navbar Section */}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 4,
        py: 1.5,
        bgcolor: "white",
        boxShadow: "0px 2px 4px rgba(0,0,0,0.05)",
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      <Box
        component="img"
        src={"https://nolegalpaisa.com/assets/images/nlp_logo.png"}
        alt="Logo"
        sx={{
          width: { xs: "150px", sm: "180px", md: "200px" },
          height: "auto",
          objectFit: "contain",
          cursor: "pointer",
          transition: "transform 0.2s ease-in-out",
          "&:hover": { transform: "scale(1.02)" },
        }}
        onClick={() => (window.location.href = "/home.html")}
      />
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Avatar sx={{ bgcolor: "primary.main", width: 32, height: 32 }}>
          <LockOutlinedIcon sx={{ fontSize: 18 }} />
        </Avatar>
        <Typography variant="h6" sx={{ color: "text.primary", fontWeight: 700 }}>
          Professional Sign Up
        </Typography>
      </Box>
      <Box sx={{ width: { xs: 0, md: "200px" } }} />
    </Box>

    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, md: 5 },
          borderRadius: 4,
          border: "1px solid #e0e0e0",
          boxShadow: "0px 10px 30px rgba(0,0,0,0.03)",
        }}
      >
        <Box component="form" noValidate>
          {/* Section 1: Basic Information */}
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 700, color: "primary.main" }}>
            Personal Details
          </Typography>
          <Grid container spacing={3} sx={{ mb: 4 }}>
            {formData.map((el: FormDataType) => (
              <Grid key={el.id} size={{ ...ControlledBoxSizeSwitch(el.boxSize) }}>
                {commonFormSwitch({
                  formObj: {
                    ...el,
                    onPasswordToggle: el.hasPasswordToggle ? () => handlePasswordToggle(el.id) : undefined,
                  },
                  onChange: (data) => setFormData(HandleFormChange(data, formData)),
                })}
              </Grid>
            ))}
          </Grid>

          <Divider sx={{ mb: 4 }} />

          {/* Section 2: Verification (Email & Contact) */}
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 700, color: "primary.main" }}>
            Contact Verification
          </Typography>
          
          {/* Email Row */}
          {/* <Grid container spacing={2} alignItems="flex-start" sx={{ mb: 3 }}>
            <Grid size={{ ...ControlledBoxSizeSwitch(4) }}>
              <ControlledForm.Input
                id="email"
                label="Email Address"
                value={emailData.fieldVal}
                {...(emailData.otpVerified && { focused: true, borderColor: "success", readOnly: true })}
                onChange={(value) => setEmailData({ ...emailData, fieldVal: value as string })}
              />
            </Grid>
            {emailData.otpSend && (
              <Grid size={{ ...ControlledBoxSizeSwitch(4) }}>
                <ControlledForm.Input
                  id="emailOtp"
                  label="Enter Email OTP"
                  value={emailData.otpVal}
                  {...(emailData.otpVerified && { iconId: "check-icon", infoText: "Verified", readOnly: true })}
                  onChange={(value) => setEmailData({ ...emailData, otpVal: value as string })}
                />
              </Grid>
            )}
            <Grid size="auto" sx={{ display: "flex", gap: 1 }}>
              <Button
                variant={emailData.otpVerified ? "outlined" : "contained"}
                color={emailData.otpVerified ? "success" : "primary"}
                sx={{ height: 50, px: 3, mt: 0.5 }}
                onClick={() => (emailData.otpSend ? handleVerifyOtp("email") : handleSendOtp("email"))}
                disabled={emailData.otpVerified}
              >
                {emailData.otpVerified ? "Verified" : emailData.otpSend ? "Verify" : "Send OTP"}
              </Button>
              <IconButton color="error" sx={{ mt: 1 }} onClick={() => setEmailData({ fieldVal: "", otpSend: false, otpVal: "", otpVerified: false })}>
                <ImgPath.RestoreIcon />
              </IconButton>
            </Grid>
          </Grid> */}

          {/* Contact Row */}
          {/* <Grid container spacing={2} alignItems="flex-start" sx={{ mb: 4 }}>
            <Grid size={{ ...ControlledBoxSizeSwitch(4) }}>
              <ControlledForm.Input
                id="contact"
                label="Contact Number"
                value={contactData.fieldVal}
                {...(contactData.otpVerified && { focused: true, borderColor: "success", readOnly: true })}
                onChange={(value) => setContactData({ ...contactData, fieldVal: value as string })}
              />
            </Grid>
            {contactData.otpSend && (
              <Grid size={{ ...ControlledBoxSizeSwitch(4) }}>
                <ControlledForm.Input
                  id="contactOtp"
                  label="Enter SMS OTP"
                  value={contactData.otpVal}
                  {...(contactData.otpVerified && { iconId: "check-icon", infoText: "Verified", readOnly: true })}
                  onChange={(value) => setContactData({ ...contactData, otpVal: value as string })}
                />
              </Grid>
            )}
            <Grid size="auto" sx={{ display: "flex", gap: 1 }}>
              <Button
                variant={contactData.otpVerified ? "outlined" : "contained"}
                color={contactData.otpVerified ? "success" : "primary"}
                sx={{ height: 50, px: 3, mt: 0.5 }}
                onClick={() => (contactData.otpSend ? handleVerifyOtp("contact") : handleSendOtp("contact"))}
                disabled={contactData.otpVerified}
              >
                {contactData.otpVerified ? "Verified" : contactData.otpSend ? "Verify" : "Send OTP"}
              </Button>
              <IconButton color="error" sx={{ mt: 1 }} onClick={() => setContactData({ fieldVal: "", otpSend: false, otpVal: "", otpVerified: false })}>
                <ImgPath.RestoreIcon />
              </IconButton>
            </Grid>
          </Grid> */}

          {/* Email Row */}
          <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
            <Grid size={{ ...ControlledBoxSizeSwitch(4) }}>
              <ControlledForm.Input
                id="email"
                label="Email Address"
                value={emailData.fieldVal}
                error={emailData.fieldVal !== "" && !validateEmail(emailData.fieldVal)}
                infoText={emailData.fieldVal !== "" && !validateEmail(emailData.fieldVal) ? "Invalid email format" : ""}
                {...(emailData.otpVerified && { focused: true, borderColor: "success", readOnly: true })}
                onChange={(value) => setEmailData({ ...emailData, fieldVal: value as string })}
              />
            </Grid>
            {emailData.otpSend && (
              <Grid size={{ ...ControlledBoxSizeSwitch(2) }}>
                <ControlledForm.Input
                  id="emailOtp"
                  label="Enter Email OTP"
                  value={emailData.otpVal}
                  {...(emailData.otpVerified && { iconId: "check-icon", infoText: "Verified", readOnly: true })}
                  onChange={(value) => {
                    const val = value as string;
                    if (val.length <= 4 && /^\d*$/.test(val)) {
                      setEmailData({ ...emailData, otpVal: val });// only allow numeric input up to 4 digits  
                    }
                  }}
                />
              </Grid>
            )}
            <Grid size="auto" sx={{ display: "flex", gap: 1 }}>
              <Button
                variant={emailData.otpVerified ? "outlined" : "contained"}
                color={emailData.otpVerified ? "success" : "primary"}
                sx={{ height: 50, px: 3, mt: 0.5, minWidth: '100px' }}
                onClick={() => (emailData.otpSend ? handleVerifyOtp("email") : handleSendOtp("email"))}
                // DISABLE IF: Already verified OR currently loading OR email is invalid OR otp field empty when verifying
                disabled={
                  emailData.otpVerified ||
                  emailLoading ||
                  !validateEmail(emailData.fieldVal) ||
                  (emailData.otpSend && emailData.otpVal.length < 4)
                }
              >
                {emailLoading ? "..." : (emailData.otpVerified ? "Verified" : emailData.otpSend ? "Verify" : "Send OTP")}
              </Button>
              <IconButton color="error" sx={{ mt: 1 }} onClick={() => setEmailData({ fieldVal: "", otpSend: false, otpVal: "", otpVerified: false })}>
                <ImgPath.RestoreIcon />
              </IconButton>
            </Grid>
          </Grid>

          {/* Contact Row */}
          <Grid container spacing={2} alignItems="center" sx={{ mb: 4 }}>
            <Grid size={{ ...ControlledBoxSizeSwitch(4) }}>
              <ControlledForm.Input
                id="contact"
                label="Contact Number"
                value={contactData.fieldVal}
                error={contactData.fieldVal !== "" && !validatePhone(contactData.fieldVal)}
                infoText={contactData.fieldVal !== "" && !validatePhone(contactData.fieldVal) ? "Must be 10 digits" : ""}
                {...(contactData.otpVerified && { focused: true, borderColor: "success", readOnly: true })}
                onChange={(value) => setContactData({ ...contactData, fieldVal: value as string })}
              />
            </Grid>
            {contactData.otpSend && (
              <Grid size={{ ...ControlledBoxSizeSwitch(2) }}>
                <ControlledForm.Input
                  id="contactOtp"
                  label="Enter SMS OTP"
                  value={contactData.otpVal}
                  {...(contactData.otpVerified && { iconId: "check-icon", infoText: "Verified", readOnly: true })}
                  onChange={(value) => {
                    const val = value as string;
                    // Manually limit to 4 characters and allow only numbers
                    if (val.length <= 4 && /^\d*$/.test(val)) {
                      setContactData({ ...contactData, otpVal: val });
                    }
                  }}
                />
              </Grid>
            )}
            <Grid size="auto" sx={{ display: "flex", gap: 1 }}>
              <Button
                variant={contactData.otpVerified ? "outlined" : "contained"}
                color={contactData.otpVerified ? "success" : "primary"}
                sx={{ height: 50, px: 3, mt: 0.5, minWidth: '100px' }}
                onClick={() => (contactData.otpSend ? handleVerifyOtp("contact") : handleSendOtp("contact"))}
                // DISABLE IF: Already verified OR currently loading OR phone is invalid OR otp field empty when verifying
                disabled={
                  contactData.otpVerified ||
                  contactLoading ||
                  !validatePhone(contactData.fieldVal) ||
                  (contactData.otpSend && contactData.otpVal.length < 4)
                }
              >
                {contactLoading ? "..." : (contactData.otpVerified ? "Verified" : contactData.otpSend ? "Verify" : "Send OTP")}
              </Button>
              <IconButton color="error" sx={{ mt: 1 }} onClick={() => setContactData({ fieldVal: "", otpSend: false, otpVal: "", otpVerified: false })}>
                <ImgPath.RestoreIcon />
              </IconButton>
            </Grid>
          </Grid>



          <Divider sx={{ mb: 4 }} />

          {/* Section 3: Professional Skills / Locations */}
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 700, color: "primary.main" }}>
            Professional Background & Locations
          </Typography>
          
          {formData1.map((el, index) => (
            <Box 
              key={el.id} 
              sx={{ 
                p: 2, 
                mb: 2, 
                borderRadius: 2, 
                bgcolor: "#f9f9f9", 
                border: "1px solid #efefef",
                position: "relative"
              }}
            >
              <Grid container spacing={2} alignItems="center">
                {el?.skillFormArr?.map((el1) => (
                 
                  <Grid key={el1.id} size={{ ...ControlledBoxSizeSwitch(4) }}>
                    {commonFormSwitch({
                      formObj: el1,
                      onChange: (props) => handleLocationChange(props, el.id),
                    })}
                  </Grid>
                ))}
                {index !== 0 && (
                  <IconButton 
                    color="error" 
                    onClick={() => removeLocationArr(el.id)}
                    sx={{ position: "absolute", top: 8, right: 8 }}
                  >
                    <CloseOutlined fontSize="small" />
                  </IconButton>
                )}
              </Grid>
            </Box>
          ))}

          <Button 
            variant="outlined" 
            startIcon={<span style={{ fontSize: 20 }}>+</span>}
            onClick={handleAddMore} 
            sx={{ mb: 4, borderRadius: 2 }}
          >
            Add More Experience/Location
          </Button>

          {/* Section 4: Document Upload */}
          <Box sx={{ 
            p: 3, 
            borderRadius: 3, 
            bgcolor: "#edf2ff", 
            border: "1px dashed #2b5ce7",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            gap: 3,
            mb: 4
          }}>
            <Box sx={{ flex: 1 }}>
              <ControlledForm.Input
                id="fileSelection"
                type="file"
                label="Qualification Documents (PDF/JPG)"
                focused={true}
                readOnly={documentsUploaded}
                onChange={(value) => setSelectedDocuments(typeof value == "object" ? value : [])}
                {...(documentsUploaded && {
                  borderColor: "success",
                  infoText: "Uploaded Successfully",
                  iconId: "check-icon",
                })}
              />
            </Box>
            <Button
              variant="contained"
              disabled={documentsUploaded}
              onClick={handleDocumentSubmission}
              sx={{ 
                minWidth: 200, 
                height: 50,
                bgcolor: documentsUploaded ? "#4CAF50" : "primary.main" 
              }}
            >
              {documentsUploaded ? "Documents Saved" : "Upload Documents"}
            </Button>
          </Box>

          {/* Final Actions */}
          {/* <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={handleRegister}
            disabled={!emailData.otpVerified && !contactData.otpVerified}
            sx={{ 
              py: 2, 
              fontSize: "1.1rem", 
              fontWeight: 700,
              borderRadius: 3,
              boxShadow: "0px 8px 20px rgba(43, 92, 231, 0.3)"
            }}
          >
            Complete Professional Registration
          </Button> */}

          {/* Final Submit Button */}
          <Button
            variant="contained"
            fullWidth
            size="large"
            sx={{ mt: 3, py: 1.5, fontWeight: 'bold' }}
            onClick={handleRegister}
            // ENABLE ONLY IF BOTH ARE VERIFIED
            disabled={!emailData.otpVerified && !contactData.otpVerified}
          >
            Complete Professional Registration
          </Button>

          <Box sx={{ mt: 4, textAlign: "center" }}>
            <Typography variant="body2" color="text.primary">
              Already have an account?{" "}
              <Typography 
                component="span" 
                variant="body2" 
                onClick={() => navigate(`/${RouteUrls.login}`)}
                sx={{ color: "primary.main", fontWeight: 700, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
              >
                Sign In
              </Typography>
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  </Box>
);
};

export default ProfessionalRegister;
